/****************************************************
 * Module Name:  cutpolsymProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CutpolsymProxy {
  static GetAllCutpolsym = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllCutpolsymMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleCutpolsym = (cutpolsymId, callback) => {
    let params = {
      id: cutpolsymId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckCutpolsymAvailable = (cutpolsym, callback) => {
    let params = {
      cutpolsym: cutpolsym,
    };

    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddCutpolsym = (cutpolsym, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(cutpolsym),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCutpolsym = (cutpolsym, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cutpolsym",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(cutpolsym),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
